import React, { Component } from 'react'
import { Footer, Link } from '@wfp/ui'

class FooterPortal extends Component {
  render() {
    return (
      <Footer
        metaContent='2024 © World Food Programme'
        pageWidth='lg'
        logo={'/images/wfp-logo-vertical-black-en.svg'}
        logoExtended={'/images/wfp-logo-extended-black-en.svg'}>
        <div className='wfp--footer-info footer-link-container'>
          <div className='wfp--footer-info__item'>
            <Link href='https://www.wfp.org' target='_blank'>
              WFP.org
            </Link>
          </div>
          <div className='wfp--footer-info__item'>
            <Link
              href='https://planning.manuals.wfp.org/en/planning/31country-operations-management-plan/'
              target='_blank'>
              Manual
            </Link>
          </div>
          <div className='wfp--footer-info__item'>
            <Link href='https://cspdata.wfp.org' target='_blank'>
              CSP Data Portal
            </Link>
          </div>
        </div>
      </Footer>
    )
  }
}

export default FooterPortal
